import axiosClient from './axiosClient';

const rideKycApi = {
  getProfiles: (params) => axiosClient.get('/rides/driver-profiles', { params }),
  getProfile: (driverProfileId) => axiosClient.get(`/rides/driver-profiles/${driverProfileId}`),
  reviewProfile: (driverProfileId, body) => axiosClient.post(`/rides/driver-profiles/${driverProfileId}/review`, body),
  createDocumentAccess: (driverProfileId, documentId) => axiosClient.post(
    `/rides/driver-profiles/${driverProfileId}/documents/${documentId}/access`
  ),
};

export default rideKycApi;
